import type { ComponentProps } from 'react';

/**
 * Liste sémantique. `<ul>` / `<ol>` / `<li>` sont interdits par la règle atomic
 * design : ce composant est la primitive qui porte les rôles ARIA équivalents.
 */
export const List = (props: ComponentProps<'div'>) => (
  <div role="list" {...props} />
);

export const ListItem = (props: ComponentProps<'div'>) => (
  <div role="listitem" {...props} />
);
